<div tickets>
  @for (_ of scheine; track $index) {
    <app-lotto-ticket
      [(numbers)]="scheine[$index]"
      [index]="$index"
      (deleteTicket)="onTicketDelete($event)"></app-lotto-ticket>
  }
  <button (click)="onTicketAdd()" mat-icon-button>
    <mat-icon>add</mat-icon>
  </button>
</div>
<div info>
  <app-datepicker [(period)]="period" [showLabel]="true" msgPeriod="Seit"></app-datepicker>
  <div grid-container>
    <div></div>
    @for (title of listTitle; track $index) {
      <div item title>{{ title }}</div>
    }
    @for (row of listRows; track $index; let y = $index) {
      <div title>{{ row.title }}</div>
      @for (day of [-1, 3, 6]; track $index) {
        <div item data [innerHTML]="row.count(y, day)"></div>
      }
    }
  </div>
</div>
